import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5tsipzrz4h: FaireBrandEntity = {
  token: "b_5tsipzrz4h",
  type: "brand",
  name: "DollyMoo",
  avatarUrl:
    "https://cdn.faire.com/fastly/66b9a9e3b692ed10ccba93af6db1749571290971c8bbe38065867a4bd3a6e4b5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dd39b9ef2143dc9a7a9073499ad319934e31589d37e5e996f9f7e1c2565ab9bd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/66b9a9e3b692ed10ccba93af6db1749571290971c8bbe38065867a4bd3a6e4b5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dd39b9ef2143dc9a7a9073499ad319934e31589d37e5e996f9f7e1c2565ab9bd.jpeg",
  location: "Montclair , NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 7,
  isInsider: true,
  description:
    "DollyMoo is a handmade bath and body company founded and created by sisters Nicci and Amy in 2010. The name \"DollyMoo\" comes from the owners' beloved Greek grandmother, Yiayia. For as long as they can remember, Yiayia used this sweet term of endearment, meaning \"My Doll.\" Her influence was, and still is, immeasurable; she was a remarkable woman with endless love to give. Guided by Yiayia's spirit, DollyMoo began at home. With a love of creating, the sisters started making products for themselves, and in almost no time at all, their friends and family were using the products as well. The genuine feedback and positive encouragement to pursue their artistry full time inspired the sisters to make it official, and they began selling DollyMoo at farmer's markets and festivals. After a few years, a lot of hard work, affirmations, and manifestation later, Nicci and Amy were fortunate enough to open the brand's brick-and-mortar in downtown Montclair, NJ. Since then, the shop and brand have flourished, building a solid, lively community of self-care, inspiring people of all walks of life to spread love, make magick, and take baths. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:00.901Z",
    importedBy: "entity-db-cli",
  },
};
